module.exports = __webpack_public_path__ + "static/media/about.e3bedb08.mp4";